import { shallowEqual, useSelector } from 'react-redux'
import { Redirect, useParams } from 'react-router-dom'
import GuestCheckoutBlockedModal from '../Checkout/GuestCheckoutBlockedModal'
import Cart from './Cart'

const CartAccessHandler = props => {
  const { shortCode: routeShortCode } = useParams()
  const { portal, currentUser, checkoutSessionShortCode } = useSelector(
    state => ({
      portal: state.portal,
      currentUser: state.currentUser,
      checkoutSessionShortCode: state.checkoutSessionToken.shortCode
    }),
    shallowEqual
  )

  if (!currentUser?.id && portal.checkout_mode === 'registered_only') {
    return <GuestCheckoutBlockedModal />
  }

  if (routeShortCode && checkoutSessionShortCode && routeShortCode !== checkoutSessionShortCode) {
    return <Redirect to={`/cart/${checkoutSessionShortCode}`} />
  }

  return <Cart {...props} />
}

export default CartAccessHandler
